import LegalPage from "../Legal/LegalPage";

// Public page required for Google OAuth brand verification. Kept deliberately
// generic: it states how Google user data is accessed, used, stored and shared
// (plus the Limited Use statement) without describing internal systems.
const PrivacyPolicy = () => {
	return (
		<LegalPage pill="Privacy" title="Privacy Policy" effective="21 September 2026">
			<p>
				Rarebox is a private, internal business application operated by Radhamani Textiles Pvt. Ltd., trading as
				The House of Rare (&quot;we&quot;, &quot;us&quot;). It is used only by our employees and authorised
				contractors, and there is no public sign-up. This policy explains how Rarebox handles data, including
				data accessed through Google APIs. It supplements the{" "}
				<a href="https://thehouseofrare.com/pages/privacy-policy" rel="noopener noreferrer" target="_blank">
					House of Rare privacy policy
				</a>
				, which covers our customer-facing website.
			</p>

			<h2>1. Information we hold</h2>
			<p>
				For each user we hold basic account details — name, work email address and sign-in credentials — and
				records of actions taken in the application, kept for security and audit purposes. We do not collect
				personal information from members of the public.
			</p>

			<h2>2. Google user data</h2>
			<p>
				With the authorisation of an administrator of our own Google Ads accounts, Rarebox uses the Google Ads
				API to read keyword research data — such as related search terms, search volumes and competition — for
				our own advertising accounts. Access is read-only: Rarebox does not create or change anything in Google
				Ads, does not access any Google Ads account other than our own, and does not access any other Google
				service.
			</p>
			<p>
				This data is used solely for our own internal marketing research and is visible only to authorised
				users within Rarebox. As part of that research, keyword data may be processed by Google&apos;s
				generative AI services to group and summarise it. No credentials and no personal information are
				included in that processing.
			</p>
			<div className="callout">
				<p>
					Rarebox&apos;s use and transfer of information received from Google APIs to any other app will adhere
					to the{" "}
					<a
						href="https://developers.google.com/terms/api-services-user-data-policy"
						rel="noopener noreferrer"
						target="_blank">
						Google API Services User Data Policy
					</a>
					, including the Limited Use requirements.
				</p>
			</div>

			<h2>3. Storage and security</h2>
			<p>
				Data is stored in access-controlled systems within our cloud infrastructure and protected by encryption
				in transit and at rest. Google authorisation credentials are stored securely and are never exposed to
				users. Access to Rarebox requires authentication and is limited by role.
			</p>

			<h2>4. Sharing</h2>
			<p>
				We do not sell, rent or trade data held in Rarebox, and we do not share Google user data with third
				parties. Data is disclosed only to the infrastructure providers that host the application on our
				behalf, under contractual confidentiality and security obligations, or where required by law.
			</p>

			<h2>5. Retention and revocation</h2>
			<p>
				Data is kept only for as long as it is useful for the purpose it was collected for, and is then
				removed. The Google Account holder can revoke Rarebox&apos;s access at any time from their{" "}
				<a href="https://myaccount.google.com/permissions" rel="noopener noreferrer" target="_blank">
					Google Account permissions page
				</a>
				, which immediately stops all further API access.
			</p>

			<h2>6. Your rights</h2>
			<p>
				Users may ask to access, correct or delete personal information we hold about them by contacting us
				below. Some records may be retained where we have a legitimate business or legal reason to do so.
			</p>

			<h2>7. Changes</h2>
			<p>We may update this policy from time to time. The effective date above reflects the latest version.</p>

			<h2>8. Contact</h2>
			<p>
				<a href="mailto:support@thehouseofrare.com">support@thehouseofrare.com</a>
			</p>
		</LegalPage>
	);
};

export default PrivacyPolicy;
